import { useQuery } from "@tanstack/react-query";
import { assetService } from "../../api/assetService";
import { getEmployeeId } from "../../utils/session";
import { MY_ASSETS_KEY } from "./assetUtils";

// Shares the My Assets "current" query, so the sidebar badge and the page
// stay in sync after an acknowledgement.
export const useMyCurrentAssets = () =>
  useQuery({
    queryKey: [MY_ASSETS_KEY, "current"],
    queryFn: () => assetService.getMyAssignments({ view: "current" }),
    enabled: !!getEmployeeId(),
    staleTime: 60 * 1000,
  });

// Assets assigned to me that I haven't confirmed receiving (sidebar badge).
export const usePendingAcknowledgements = () =>
  useMyCurrentAssets().data?.pendingAcknowledgement ?? 0;
